import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    container: {
      borderRadius: theme.spacing(3),
      backgroundColor: theme.palette.background.default,

      color: theme.palette.text.primary,

      paddingTop: theme.spacing(8),
      paddingX: theme.spacing(5),
      paddingBottom: theme.spacing(9),

      [theme.breakpoints.up('lg')]: {
        paddingTop: theme.spacing(10),
        paddingX: theme.spacing(9),
        paddingBottom: theme.spacing(12),
        borderRadius: theme.spacing(4),
      },
    },
  };
};
